import React, { FC } from "react";
import {
  Button,
  Link,
  ModalDialog,
  ModalDialogBody,
  ModalDialogButtons,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogNav,
  ModalDialogTitle,
} from "@vp/swan";

export interface SignInModalProps {
  isOpen: boolean;
  labels: {
    title: string;
    description: string;
    primaryButton: string;
    secondaryButton: string;
  };
  onSignInHandler: () => void;
  onSignInLaterHandler?: () => void;
  onDismissModalHandler?: () => void;
  url: string;
}

export const SignInModal: FC<SignInModalProps> = ({
  isOpen,
  labels,
  onSignInHandler,
  onSignInLaterHandler,
  onDismissModalHandler,
  url,
}) => {
  const {
    title,
    description,
    primaryButton: primaryButtonLabel,
    secondaryButton: secondaryButtonLabel,
  } = labels;

  const onSignInLater = () => {
    onSignInLaterHandler?.();
  };

  const onDismissModal = () => {
    onDismissModalHandler?.();
  };

  return (
    <ModalDialog bodyWidth="capped" isOpen={isOpen} onRequestDismiss={onDismissModal}>
      <ModalDialogContent aria-labelledby="sign-in-modal-dialog-title">
        <ModalDialogNav>
          <ModalDialogCloseButton accessibleText={"Close"} />
        </ModalDialogNav>
        <ModalDialogHeader>
          <ModalDialogTitle id="sign-in-modal-dialog-title">{title}</ModalDialogTitle>
        </ModalDialogHeader>
        <ModalDialogBody>{description}</ModalDialogBody>
        <ModalDialogFooter pinned>
          <ModalDialogButtons>
            <Button
              skin="secondary"
              fontSize="small"
              render={props => (
                <Link to={url} className={props.className} onClick={onSignInLater}>
                  {props.children}
                </Link>
              )}
            >
              {secondaryButtonLabel}
            </Button>
            <Button skin="primary" fontSize="small" onClick={onSignInHandler}>
              {primaryButtonLabel}
            </Button>
          </ModalDialogButtons>
        </ModalDialogFooter>
      </ModalDialogContent>
    </ModalDialog>
  );
};
